import type { WBlogPopularPostsTranslations } from "./pl";

export const en: WBlogPopularPostsTranslations = {
  readMore: "Read more",
  empty: "No popular posts.",
};
